import { isString } from 'angular';
import { Directive, Inject, Input, OnInit } from 'angular-ts-decorators';

import { IAnchorBarItem } from '../models/anchor-bar-item';

import { IAnchorBarService } from '../services/anchor-bar.service';

@Directive({
  selector: '[anchorBarItem]',
})
export class AnchorBarItemDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$scope', 'anchorBarService'];

  @Input('@') public anchorBarTitle?: string;
  @Input('@') public id?: string;
  @Input('@') public lazyAnchorBarItem?: string;

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('anchorBarService') private anchorBarService: IAnchorBarService
  ) { }

  public ngOnInit(): void {
    const item: IAnchorBarItem = {
      id: this.id,
      selected: false,
      title: this.anchorBarTitle,
    };

    if (isString(this.lazyAnchorBarItem) && this.lazyAnchorBarItem !== '') {
      this.$scope.$watch(this.lazyAnchorBarItem, (newValue: boolean): void => {
        if (newValue === true) {
          this.anchorBarService.add(item);
        } else {
          this.anchorBarService.remove(item);
        }
      });
    } else if (this.lazyAnchorBarItem !== '') {
      this.anchorBarService.add(item);
    }
  }
}
